<div id="page-wrap">
    <div class="inner-page-wrap">
        <app-navbar></app-navbar>
        <iframe src="https://shuffll.co/terms/"></iframe>
    </div>
</div>
